import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box, IconButton, Slide, Typography } from '@mui/material';

const listeners = new Set();
let toastId = 0;
let lastToast = { key: '', time: 0 };

function notify(toast) {
  listeners.forEach((listener) => listener(toast));
}

export function showToast({ message = 'Success!', severity = 'success', duration = 5000 } = {}) {
  const key = `${severity}:${message}`;
  const now = Date.now();

  if (lastToast.key === key && now - lastToast.time < 1200) {
    return null;
  }

  lastToast = { key, time: now };
  toastId += 1;
  const toast = {
    id: `${now}-${toastId}`,
    message,
    severity,
    duration,
  };

  notify(toast);
  return toast.id;
}

export function ToastViewport() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const listener = (toast) => {
      setToasts((currentToasts) => [...currentToasts, toast].slice(-4));
    };

    listeners.add(listener);
    return () => listeners.delete(listener);
  }, []);

  useEffect(() => {
    const timers = toasts.map((toast) =>
      setTimeout(() => {
        setToasts((currentToasts) =>
          currentToasts.filter((currentToast) => currentToast.id !== toast.id)
        );
      }, toast.duration)
    );

    return () => timers.forEach(clearTimeout);
  }, [toasts]);

  const handleClose = (id) => {
    setToasts((currentToasts) => currentToasts.filter((toast) => toast.id !== id));
  };

  return (
    <Box className="hm-toast-viewport" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <Slide key={toast.id} in direction="right" timeout={180} mountOnEnter unmountOnExit>
          <Alert
            severity={toast.severity}
            className="hm-toast-alert"
            action={
              <IconButton
                aria-label="close"
                className="hm-toast-close"
                size="small"
                onClick={() => handleClose(toast.id)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          >
            <Typography className="hm-toast-message">{toast.message}</Typography>
          </Alert>
        </Slide>
      ))}
    </Box>
  );
}
